/**
 * Adobe Analytics data layer — mirrors Blazor Web/wwwroot/js/AdobeAnalyticsDataLayer.js
 *
 * The Blazor app called these via JSInterop (`JSRuntime.InvokeVoidAsync`).
 * This module exposes the same functions as first-class TypeScript.
 */

declare global {
  interface Window {
    _satellite?: { track: (event: string) => void };
    analyticsDataLayer?: AnalyticsDataLayer | null;
  }
}

interface AnalyticsDataLayer {
  pageInfo: {
    pageName: string;
    userID: string;
    applicationName: string;
    actionName?: string;
    searchTerm?: string;
    moduleName: string;
  };
}

const APP_NAME = 'DU Next Gen';

/**
 * Track a user action (search, button click, etc.)
 */
export function trackAction(
  pageName: string,
  userId: string,
  actionName: string,
  searchTerm: string | null,
  moduleName: string,
): void {
  window.analyticsDataLayer = {
    pageInfo: {
      pageName,
      userID: userId,
      applicationName: APP_NAME,
      actionName,
      searchTerm: searchTerm ?? '',
      moduleName,
    },
  };
  window._satellite?.track('action');
}

/**
 * Track a page view
 */
export function trackPageView(
  pageName: string,
  userId: string,
  moduleName: string,
): void {
  window.analyticsDataLayer = {
    pageInfo: {
      pageName,
      userID: userId,
      moduleName,
      applicationName: APP_NAME,
    },
  };
  window._satellite?.track('pageView');
}
